// Module
var code = `<div class="page"> <div class="panel"> Apply </div> </div>`;
// Exports
export default code;